var map = {
	"./address.svg": "Irkx",
	"./headTopNavApp.svg": "xv+C",
	"./headTopNavAppRed.svg": "9BHx",
	"./headTopNavEn.svg": "taXQ",
	"./headTopNavEnRed.svg": "AWGD",
	"./headTopNavWechat.svg": "tNNb",
	"./headTopNavWechatRed.svg": "9flP",
	"./logo-R.svg": "elGZ",
	"./logo-white.svg": "JC0Q",
	"./logo.svg": "NjnU",
	"./more.svg": "UDzx",
	"./postalCode.svg": "Fpuw",
	"./print.svg": "8Vt1",
	"./redArrow.svg": "ekNb",
	"./tel.svg": "+Hk/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 22